import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { BehaviorSubject, distinctUntilChanged } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  private isLoading = new BehaviorSubject<boolean>(true);
  public isLoading$ = this.isLoading.pipe(distinctUntilChanged());

  private activeLoaders = 0;
  constructor(@Inject(PLATFORM_ID) private platformId: Object){}

  show(): void {    
    this.activeLoaders++;
    if (this.activeLoaders === 1) {
      this.isLoading.next(true);
      if (isPlatformBrowser(this.platformId)) {
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
      }
    }
  }

  hide(): void {
    if (this.activeLoaders > 0) {
      this.activeLoaders--;
    }
    
    if (this.activeLoaders === 0) {
      this.isLoading.next(false);
      if (isPlatformBrowser(this.platformId)) {
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
      }
    }
  }

  reset(): void {
    this.activeLoaders = 0;
    this.hide();
  }
}